import alertCheck from '/assets/icons/alert/icon-alert-check.svg?url';
import alertError from '/assets/icons/alert/icon-alert-error.svg?url';
import alertInfo from '/assets/icons/alert/icon-alert-info.svg?url';

import back from '/assets/icons/arrow/icon-arrow-back.svg?url';
import downLight from '/assets/icons/arrow/icon-arrow-down-light.svg?url';
import down from '/assets/icons/arrow/icon-arrow-down-normal.svg?url';
import download from '/assets/icons/arrow/icon-arrow-download.svg?url';
import leftLight from '/assets/icons/arrow/icon-arrow-left-light.svg?url';
import left from '/assets/icons/arrow/icon-arrow-left-normal.svg?url';
import rightLight from '/assets/icons/arrow/icon-arrow-right-light.svg?url';
import right from '/assets/icons/arrow/icon-arrow-right-normal.svg?url';
import upLight from '/assets/icons/arrow/icon-arrow-up-light.svg?url';
import up from '/assets/icons/arrow/icon-arrow-up-normal.svg?url';
import upload from '/assets/icons/arrow/icon-arrow-upload.svg?url';

import closeBlack from '/assets/icons/common/icon-close-black.svg?url';
import closeYellow from '/assets/icons/common/icon-close-yellow.svg?url';
import close from '/assets/icons/common/icon-close.svg?url';
import database from '/assets/icons/common/icon-database.svg?url';
import dollhouse from '/assets/icons/common/icon-dollhouse.svg?url';
import dotHover from '/assets/icons/common/icon-dot-hover.png?url';
import dotLine from '/assets/icons/common/icon-dot-line.png?url';
import dot from '/assets/icons/common/icon-dot.png?url';
import edit from '/assets/icons/common/icon-edit.svg?url';
import floorPlan from '/assets/icons/common/icon-floor-plan.svg?url';
import fullsize from '/assets/icons/common/icon-fullsize.svg?urk';
import locationPath from '/assets/icons/common/icon-location-path.svg?url';
import marker from '/assets/icons/common/icon-marker.svg?url';
import onePerson from '/assets/icons/common/icon-one-person.svg?url';
import panorama from '/assets/icons/common/icon-panorama.svg?url';
import passwordOn from '/assets/icons/common/icon-password-visible-on.svg?url';
import passwordOff from '/assets/icons/common/icon-password-visible-off.svg?url';
import poi from '/assets/icons/common/icon-poi.svg?url';
import rectangle from '/assets/icons/common/icon-rectangle.svg?url';
import reset from '/assets/icons/common/icon-reset.svg?url';
import risk from '/assets/icons/common/icon-risk.svg?url';
import site from '/assets/icons/common/icon-site.svg?url';
import thirdPerson from '/assets/icons/common/icon-third-person.svg?url';
import timeline from '/assets/icons/common/icon-timeline.svg?url';

import menuOpen from '/assets/icons/menu/icon-menu-open.svg?url';
import menuClose from '/assets/icons/menu/icon-menu-close.svg?url';

/**
 * 알림 아이콘
 */
export const alertIcons = {
  alertCheck,
  alertError,
  alertInfo
};

/**
 * 공통 아이콘
 */
export const commonIcons = {
  closeBlack,
  closeYellow,
  close,
  database,
  dollhouse,
  dotHover,
  dotLine,
  dot,
  edit,
  floorPlan,
  fullsize,
  locationPath,
  marker,
  onePerson,
  panorama,
  passwordOn,
  passwordOff,
  poi,
  rectangle,
  reset,
  risk,
  site,
  thirdPerson,
  timeline
};

/**
 * 화살표 아이콘
 */
export const arrowIcons = {
  back,
  downLight,
  down,
  download,
  leftLight,
  left,
  rightLight,
  right,
  upLight,
  up,
  upload
};

/**
 * 메뉴 아이콘
 */
export const menuIcons = { menuOpen, menuClose };
